import React, {useState} from 'react'
import style from './index.module.scss'
import baseStyle from '../../../styles/base.module.scss';
import Tooltip from "@material-ui/core/Tooltip";
import parse from "html-react-parser";
import TooltipIcon from './tooltipIcon.svg'

export const Label = (props) => {

    const [open, setOpen] = React.useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    }

    const handleTooltipOpen = () => {
        setOpen(true);
    }

    function customToolTip(){
        return (
            <div>
                <div className={style.tooltipTitle} style={(props.autosize)?{whiteSpace: 'normal', paddingRight: '10px'}:{}}>
                    {parse(props.tooltipText)}
                </div>
            </div>
        )
    }

    return (
        <div className={style.main}>
            <label className={`${style.inputlabel}  ${baseStyle.t_grey_800}`}>{props.children}</label>
            {(props.tooltip)?
                <Tooltip
                    arrow
                    title={customToolTip()}
                    placement="top-start"
                    className={style.tooltip}
                    onClose={handleTooltipClose}
                    open={open}>
                        <div onClick={handleTooltipOpen} onMouseOver={handleTooltipOpen}>
                            <TooltipIcon fill={(props.whiteMode)?"#FFF":"#4B6584"}/>
                        </div>
                </Tooltip>
            :null}
        </div>
    )
}